import React from 'react'

export function useTranslation(key) {
  const translations = window.translations
  if (typeof translations !== 'object') {
    return null
  }

  const keyParts = key.split('.')
  let value = null
  for (let i = 0; i < keyParts.length; i++) {
    value = value === null ? translations[keyParts[i]] : value[keyParts[i]]
  }

  return value
}
